export const SESSION_EXPIRED_EVENT = 'growme:session-expired';
export const PASSWORD_CHANGE_REQUIRED_EVENT = 'growme:password-change-required';

// El back respondió 403 PASSWORD_CHANGE_REQUIRED: la sesión sigue siendo válida
// pero el usuario debe cambiar su contraseña antes de usar la plataforma.
export const notifyPasswordChangeRequired = (): void => {
  window.dispatchEvent(new Event(PASSWORD_CHANGE_REQUIRED_EVENT));
};

const SESSION_EXPIRED_FLAG = 'sessionExpired';

// Llamado cuando el back responde 401 con una sesión activa: limpia el token y
// avisa a la app para que vuelva al login (ver AllRoutes en grow-me/index.tsx).
// Si no hay token no hace nada, así los flujos públicos (tests, checkout guest)
// nunca se ven afectados.
export const notifySessionExpired = (): void => {
  if (!localStorage.getItem('token')) return;

  localStorage.removeItem('token');
  sessionStorage.setItem(SESSION_EXPIRED_FLAG, 'true');
  window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
};

// Lo consume el login para mostrar el aviso una sola vez.
export const consumeSessionExpiredFlag = (): boolean => {
  const expired = sessionStorage.getItem(SESSION_EXPIRED_FLAG) === 'true';
  sessionStorage.removeItem(SESSION_EXPIRED_FLAG);
  return expired;
};
